import type { Element as XmlEl } from "@xmpp/xml"
import type { TombstoneMessage } from "../../../../types"
import { NS_MESSAGE_RETRACT } from "../../../constants"
import { InvalidStanza } from "../exceptions"
import { attr } from "../../../xmlUtils"

function retracted(stanza: XmlEl) {
  return stanza.getChild("retracted", NS_MESSAGE_RETRACT)
}

export function isTombstone(stanza: XmlEl): boolean {
  return !!retracted(stanza)
}

export function parseTombstone(
  stanza: XmlEl
): Pick<TombstoneMessage, "id" | "type" | "retracted"> {
  const tag = retracted(stanza)
  if (!tag) throw new InvalidStanza("not a tombstone", stanza)

  // The replaced message's id, so the stub lands in its slot, not a new row.
  const id = attr(tag, "id")
  if (!id) throw new InvalidStanza("tombstone names no message", stanza)

  return { id, type: "tombstone", retracted: true }
}
